// extracted by mini-css-extract-plugin
export var emphasize = "styles-module--emphasize--8c958";
export var logo = "styles-module--logo--3cfeb";
export var logos = "styles-module--logos--d638f";
export var outer = "styles-module--outer--6bb6d";
export var wrapper = "styles-module--wrapper--6d11d";